import { render } from "./GameTimeline.vue?vue&type=template&id=0a38b29c"
import script from "./GameTimeline.vue?vue&type=script&lang=js"
export * from "./GameTimeline.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/GameTimeline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a38b29c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a38b29c', __exports__)) {
    api.reload('0a38b29c', __exports__)
  }
  
  module.hot.accept("./GameTimeline.vue?vue&type=template&id=0a38b29c", () => {
    api.rerender('0a38b29c', render)
  })

}


export default __exports__